import { createContext, useContext } from 'react';

const AccordionContext = createContext();

export const useAccordionContext = () => {
  const context = useContext(AccordionContext);

  if (!context) {
    throw new Error('Child components of SummaryAccordion cannot be rendered outside the SummaryAccordion Component!');
  }

  return context;
};

export { AccordionContext };
